import Vue from 'vue'
import Vuex from 'vuex'

import common from '@/store/modules/common'
import dnote from '@/store/modules/dnote'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    common,
    dnote,
  },
})
